export * from "./symbol-legend.component";
